/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverAdminListedDtoAdmin } from '../models/DriverAdminListedDtoAdmin';
import type { DriverDocumentEtaDto } from '../models/DriverDocumentEtaDto';
import type { DriverDocumentRequestAdmin } from '../models/DriverDocumentRequestAdmin';
import type { GetDriverDocumentEtaResponse } from '../models/GetDriverDocumentEtaResponse';
import type { PostDriverDocumentsRequestAdmin } from '../models/PostDriverDocumentsRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverDocumentsService {
    /**
     * @returns GetDriverDocumentEtaResponse Created
     * @throws ApiError
     */
    public static getDriverDocumentDriver(): CancelablePromise<GetDriverDocumentEtaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverdocuments/driver/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverDocuments`
     * @returns DriverDocumentEtaDto Created
     * @throws ApiError
     */
    public static postDriverDocumentAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverDocumentsRequestAdmin,
    }): CancelablePromise<DriverDocumentEtaDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverdocuments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverDocuments`
     * @returns GetDriverDocumentEtaResponse Created
     * @throws ApiError
     */
    public static getDriverDocumentAdmin({
        driverId,
    }: {
        driverId: number,
    }): CancelablePromise<GetDriverDocumentEtaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverdocuments/driver/{driverId}',
            path: {
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverDocuments`
     * @returns DriverAdminListedDtoAdmin Created
     * @throws ApiError
     */
    public static getMissingDriverDocumentsAdmin({
        driverId,
        regionId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        driverId?: number,
        regionId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<DriverAdminListedDtoAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverdocuments/missing-drivers',
            query: {
                'driverId': driverId,
                'regionId': regionId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverDocuments`
     * @returns DriverDocumentEtaDto OK
     * @throws ApiError
     */
    public static putDriverDocumentAdmin({
        documentId,
        requestBody,
    }: {
        documentId: number,
        requestBody?: DriverDocumentRequestAdmin,
    }): CancelablePromise<DriverDocumentEtaDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/driverdocuments/{documentId}',
            path: {
                'documentId': documentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
